import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Project } from '@src/app/models/project';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerprojectlistService {

  constructor(private http:HttpClient) { }

    //GET	    /customer/{customerId}/project/list/pit/{pitdate}
    // getCustomerProjects(pit:string,customerId:string){
    //   const httpOptions = {
    //     headers: new HttpHeaders({
    //       'Content-Type': 'application/json',
    //       'Authorization': SessionHelper.getIdToken()
    //     })
    //   }
    //   return this.http.get<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId+'/project/list/pit/'+pit,httpOptions);
  
    // }
}
